import { ClipsalFlavour } from './flavours/ClipsalFlavour'
import { BuildFlavour } from './flavours/BuildFlavour'
import { PdlFlavour } from './flavours/PdlFlavour'

let brandConfig: BuildFlavour

switch (process.env.REACT_APP_FLAVOUR) {
  case 'PDL':
    brandConfig = PdlFlavour
    break
  default:
    brandConfig = ClipsalFlavour
}

export const BuildConfig = {
  brand: brandConfig,
}